import {
  TEXT_EDITOR_DEFAULT_SIZE,
  TEXT_EDITOR_SIZE_LARGE,
  TEXT_EDITOR_SIZE_SINGLE_LINE
} from "shared/utils/styleConstants";

/**
 * @description Type of input field
 */
export enum InputType {
  TEXT = "text",
  NUMBER = "number",
  RADIO = "radio",
  CHECKBOX = "checkbox",
  PASSWORD = "password"
}

/**
 * @description Denotes style to use for radio options
 */
export enum RadioOptionsDisplayStyle {
  HORIZONTAL = "horizontal", // side by side
  VERTICAL = "vertical" // one below the other
}

export enum FormTextEditorSize {
  SINGLE_LINE = TEXT_EDITOR_SIZE_SINGLE_LINE,
  DEFAULT_SIZE = TEXT_EDITOR_DEFAULT_SIZE,
  LARGE = TEXT_EDITOR_SIZE_LARGE
}

export enum CustomAssetUploadErrorCode {
  ASPECT_RATIO_INCORRECT = "aspect.ratio.incorrect",
  DIMENSION_INCORRECT = "image.dimension.incorrect"
}
